import request from '@/utils/request'

/***
 * 产品信息
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getProductList = async (queryForm) => await request.post("qtProduct/list", queryForm);

/***
 * 新闻信息
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getNewsList = async (queryForm) => await request.post("qtProduct/newsList", queryForm);
/***
 * 下载信息
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getDownloadList = async (queryForm) => await request.post("qtProduct/fileList", queryForm);

/***
 * 产品id查询参数
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getProductByID = (data) => request.get("qtProduct/productParmes/" + data)

/***
 * 新闻id查询参数
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getNewsByID = (data) => request.get("qtProduct/news/" + data)

/***
 * 产品id查询详情参数
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getProductDetailByID = (data) => request.get("qtProduct/" + data)

/***
 * 留言提交
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getLiuyanList = async (ruleForm) => await request.post("message/save", ruleForm);

/***
 * 字典接口 分类下拉框查询
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getDicList = (data) => request.get("/qtProduct/getByDicName/" + data)


